import { render, staticRenderFns } from "./OperateColumn.vue?vue&type=template&id=0555c545&scoped=true&"
import script from "./OperateColumn.vue?vue&type=script&lang=js&"
export * from "./OperateColumn.vue?vue&type=script&lang=js&"
import style0 from "./OperateColumn.vue?vue&type=style&index=0&id=0555c545&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0555c545",
  null
  
)

export default component.exports